<template lang="pug" src="./selectedEntries.pug"></template>

<script>
import moment from 'moment'
import ReopenAllotmentModal from './modals/ReopenAllotmentModal'
import ApplyModal from './modals/ApplyModal'
import JustifyModal from './modals/JustifyModal'
import EntryManager from './EntryManager'
import Justifications from './Justifications'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import { maskThousand } from '../../../utils/numberMasker.js'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import FuncionalidadeIdEnum from '../../../enum/funcionalidadeId.js'

export default {
  name: 'SelectedEntries',

  components: {
    ReopenAllotmentModal,
    ApplyModal,
    JustifyModal,
    EntryManager,
    Justifications,
    ButtonPrimary
  },

  data () {
    return {
      internalEntries: [],
      bankEntries: [],
      justifications: []
    }
  },

  computed: {
    allotmentMovementRemoved () {
      return this.$store.getters.allotmentMovementRemoved
    },

    allotmentId () {
      return this.$store.getters.idAllotment
    },

    hasPendingFinMov () {
      return this.$store.getters.hasPendingFinMov
    },

    hasPendingBankStat () {
      return this.$store.getters.hasPendingBankStat
    },

    totalAmountForInternalEntries () {
      return this.$store.getters.totalAmountForInternalEntries
    },

    totalAmountForBankEntries () {
      return this.$store.getters.totalAmountForBankEntries
    },

    totalAmountToJustify () {
      return this.calculateTotalToJustify()
    },

    totalDivergence () {
      let value = Number(Number(this.totalAmountForBankEntries) - Number(this.totalAmountForInternalEntries) - Number(this.totalAmountToJustify)).toFixed(2)
      return Number(value).toFixed(2)
    },

    totalTransformed () {
      return maskThousand(this.totalDivergence)
    },

    divergentInstance () {
      return Number(this.totalDivergence).toFixed(2) !== '0.00' || this.totalAmoutOfEntriesMov > 0 || this.totalAmountOfEntriesBank > 0
    },

    canReopen () {
      return this.allotmentId && !this.hasPendingBankStat && !this.hasPendingFinMov
    },

    canConciliate () {
      return (this.internalEntries.length > 0 && this.bankEntries.length > 0 && (this.hasPendingBankStat || this.hasPendingFinMov) || this.arrayJustify.length > 0)
    },

    canResumeConciliation () {
      return this.canConciliate
    },

    finMovAdded () {
      return this.$store.getters.finMovAdded
    },

    bankStatAdded () {
      return this.$store.getters.bankStatAdded
    },

    totalAmountOfEntriesBank () {
      return this.bankEntries.length
    },

    totalAmoutOfEntriesMov () {
      return this.internalEntries.length
    },

    sumMov () {
      let value = 0.00
      this.internalEntries.forEach(entry => {
        value = this.round(value, 2) + this.round(entry.valor, 2)
      })
      this.sumAmount = value
      return maskThousand(value)
    },

    rangeDateMov () {
      let startDate = new Date('01/01/9999')
      let endDate = new Date('01/01/1900')
      this.internalEntries.forEach(entry => {
        let date = entry.dtLanc ? entry.dtLanc : entry.data
        if (moment(date).isBefore(startDate)) {
          startDate = date
        }

        if (moment(date).isAfter(endDate)) {
          endDate = date
        }
      })

      return this.totalAmoutOfEntriesMov > 0
        ? startDate === endDate
          ? moment(startDate).format('DD/MM/YYYY')
          : moment(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + moment(endDate).format('DD/MM/YYYY')
        : ' - '
    },

    sumBank () {
      let value = 0.00
      this.bankEntries.forEach(entry => {
        value = this.round(value, 2) + this.round(entry.valor, 2)
      })
      this.sumAmount = value
      return maskThousand(value)
    },

    rangeDateBank () {
      let startDate = new Date('01/01/9999')
      let endDate = new Date('01/01/1900')
      this.bankEntries.forEach(entry => {
        let date = entry.dtLanc ? entry.dtLanc : entry.data
        if (moment(date).isBefore(startDate)) {
          startDate = date
        }

        if (moment(date).isAfter(endDate)) {
          endDate = date
        }
      })

      return this.totalAmountOfEntriesBank > 0
        ? startDate === endDate
          ? moment(startDate).format('DD/MM/YYYY')
          : moment(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + moment(endDate).format('DD/MM/YYYY')
        : ' - '
    },

    arrayJustify () {
      return this.$store.getters.arrayJustify
    },

    resumeAutomaticProcessing () {
      return this.$store.getters.isConciliationResumed
    },

    verifyAuthorizationResumeProcess () {
      if (this.$store.getters.allowedFuncionalities) {
        return !!this.$store.getters.allowedFuncionalities
                .find(element => element === FuncionalidadeIdEnum.RETOMAR_CONCILIACAO)
      }
      return false
    }
  },

  watch: {
    finMovAdded () {
      this.internalEntries = this.$store.getters.finMovAdded
      this.verifyAndCleanJustify()
    },

    bankStatAdded () {
      this.bankEntries = this.$store.getters.bankStatAdded
      this.verifyAndCleanJustify()
    },

    arrayJustify () {
      this.justifications = this.$store.getters.arrayJustify
    }
  },

  methods: {
    // Limpa as jutificativas adicionadas, caso o usuário tenha removido todos os lançamentos do lado do movimento financeirou ou do extrato bancário
    verifyAndCleanJustify () {
      if (this.internalEntries.length === 0 || this.bankEntries.length === 0) {
        this.cleanJustify()
      }
    },

    // Limpa as justificativas adicionadas
    cleanJustify () {
      this.$store.dispatch('cleanArrayJustify')
        .then(() => {
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    reaopenAllotment () {
      $('#reopenAllotmentModal').modal({ backdrop: 'static', keyboard: false })
    },

    applyConciliation () {
      $('#applyModal').modal({ backdrop: 'static', keyboard: false })
    },

    justifyAllotment () {
      $('#justifyModal').modal({ backdrop: 'static', keyboard: false })
    },

    // Calcula o valor total a ser justificado
    calculateTotalToJustify () {
      let value = 0.00
      this.arrayJustify.forEach(justify => {
        value += justify.valor
      })
      return value
    },

    // Retorna a classe que seta a cor do valor de divergência, caso seja = 0, a cor é verde, se não a cor é vermelha
    getDivergenceAmoutClass () {
      return this.divergentInstance ? 'divergence-value' : 'conciliated-value'
    },

    clearMovTable () {
      trackAnalyticsEvent(this, 'conciliacao-manual', 'click-limpar-movimentacoes')

      let movList = this.internalEntries.slice()
      this.$store.dispatch('removeAllMovFin', movList)
        .then(() => {
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    clearBankTable () {
      trackAnalyticsEvent(this, 'conciliacao-manual', 'click-limpar-extratos')

      let bankList = this.bankEntries.slice()
      this.$store.dispatch('removeAllBankStat', bankList)
        .then(() => {
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    removeAllotment () {
      let data = {
        idAllotmentRemoved: this.$store.getters.idRowAllotmentMovementAdded,
        idAllotmentToRemove: this.$store.getters.idRowAllotmentMovementAdded
      }
      this.$store.dispatch('removeAllotment', data)
    },

    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },

    changeReaplyConciliation (event) {
      this.$store.dispatch('setReaplyConciliation', event.target.checked)
    }
  }
}
</script>

<style>
.mid-button {
  margin-left: 2vw !important;
  margin-right: 2vw !important;
  background-color: #40b9bb;
  border: 1px solid #40b9bb;
  color: #FFF;
}

.mid-button:hover {
  background-color: #379d9e;
  border: 1px solid #379d9e;
  color: #FFF;
}

.mid-button[disabled] {
  background-color: #c7c7c7;
  border: 1px solid #c7c7c7;
  color: #FFF;
}

.mid-button[disabled]:hover {
  background-color: #c7c7c7;
  border: 1px solid #c7c7c7;
}

.pending-divergence {
  text-align: center;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  margin-top: 3vh;
  font-size: 2vh;
}

.divergence-value {
  text-align: center;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 4vh;
  color: red;
}

.conciliated-value {
  text-align: center;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 4vh;
  color: green;
}

.clear-link {
  text-decoration: underline;
  margin-right: 2%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.search-button {
  min-width: 7vw !important;
}

.total-values {
  padding-top: 30px;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.row-flex {
  display: flex;
  /* equal height of the children */
}

.col-flex {
  flex: 1;
  /* additionally, equal width */
}

.span-tag {
  background-color: #f3f8fe;
  border-radius: 5px;
  border: 1px solid #cccccc;
  color: #1a3b5f;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  padding: 3px 3px 3px 6px;
}

.close-tag-btn {
  border: 0px;
  background: transparent;
  padding: 0px 0px 0px 5px;
  margin: 0px;
}

.close-tag-span {
  color: #1a3b5f !important;
  font-size: 12px;
  padding-right: 5px;
  font-weight: bold;
}

.checkbox-centered {
  display: flex;
  justify-content: center;
  margin-left: 20px
}
</style>



// WEBPACK FOOTER //
// SelectedEntries.vue?ac777bce